import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const AccordionIntroComponent = React.lazy(() => import("../Components/RootComponents/AccordionIntroComponent"));
const AccordionIntroPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <AccordionIntroComponent />
      </Suspense>
    </Fragment>
  );
};

export default AccordionIntroPage;
